import {
    HomeOutline,
    LockOutline,
    LogoutOutline,
    MenuOutline,
    MenuUnfoldOutline,
    ProfileOutline,
    SettingOutline,
    UserOutline,
    SendOutline,
    SearchOutline,
} from "@ant-design/icons-angular/icons";

export const icons = [
    MenuUnfoldOutline,

    LogoutOutline,
    HomeOutline,
    SettingOutline,
    LockOutline,
    ProfileOutline,
    UserOutline,
    MenuOutline,
    SendOutline,
    SearchOutline,
];
